import { z } from 'zod';

export const formSchema = z.object({
  label: z.string().min(1, { message: 'Required' }),
  value: z
    .string()
    .regex(/^\d*\.?\d*$/, { message: 'Must be a number' })
    .refine((val) => parseFloat(val) > 0, {
      message: 'Must be greater than 0'
    }),
  type: z.string().min(1, { message: 'Required' })
});
